import { useContext, useEffect, useRef, useState } from "react";
import Header from "../../components/Header";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import { GoDotFill, GoTrash } from "react-icons/go";
import Accordion from "react-bootstrap/Accordion";
import { MdOutlineModeEdit } from "react-icons/md";
import Cloud from "../../Assets/Images/cloud.png";
import PdfImage from "../../Assets/Images/pdf.png";
import { FaCircleCheck } from "react-icons/fa6";
import { IoMdCloseCircle } from "react-icons/io";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { BASE_URL, DELETE_LAB_RESULT, GET_LAB_RESULTS, UPLOAD_LAB_RESULTS } from "../../API";
import { dateFormatter } from "../../utils/helper";
import { ProfileContext } from "../../context/ProfileContext";

function PatientRecordDetails() {
  const { headers } = useContext(ProfileContext)
  const location = useLocation();
  const TOKEN = localStorage.getItem('token')
  const [show1, setShow1] = useState(false);
  const [patientRecord, setPatientRecord] = useState([]);
  const [show, setShow] = useState(false);
  const [showReportNameModal, setShowReportNameModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [reportName, setReportName] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [currentPatientDetail, setCurrentPatientDetail] = useState(location.state);
  const [activeConsultationId, setActiveConsultationId] = useState(null);
  const [consId, setConsID] = useState(null);
  const [activeChiefComplaint, setActiveChiefComplaint] = useState("");
  const [activeMedicalDiagnosis, setActiveMedicalDiagnosis] = useState("");
  const [activeFollowUps, setActiveFollowUps] = useState("");
  const [timestamp, setTimestamp] = useState("");
  const [medicalDiagnosis, setMedicalDiagnosis] = useState("");
  const [followUpReminder, setFollowUpReminder] = useState("");
  const [activeRecordId, setActiveRecordId] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [labReport, setLabReport] = useState([]);
  const [totalAccordion, setTotalAccordion] = useState([]);

  const handleClose1 = () => { setShow1(false); setFollowUpReminder(""); }
  const handleShow1 = (record) => {
    setFollowUpReminder(record.followUps || "");
    setActiveRecordId(record.sessionId)
    setActiveChiefComplaint(record.chiefComplaint || "");
    setActiveFollowUps(record.followUps || "");
    setActiveMedicalDiagnosis(record.medicalDiagnosis || "");
    setTimestamp(record.timestamp || new Date().toISOString());
    setShow1(true);
  }
  const handleClose = () => {
    setShow(false);
    setMedicalDiagnosis("");
  }

  const handleShow = (record) => {
    setMedicalDiagnosis(record.medicalDiagnosis || "")
    setActiveChiefComplaint(record.chiefComplaint || "");
    setActiveMedicalDiagnosis(record.medicalDiagnosis || "");
    setActiveFollowUps(record.followUps || "");
    setTimestamp(record.timestamp || new Date().toISOString());
    setActiveRecordId(record.sessionId)
    setShow(true);
  }
  const handleShowReportNameModal = () => setShowReportNameModal(true);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") { setDragActive(true) }
    else if (e.type === "dragleave") { setDragActive(false) }
  };

  // Handle drop event
  const handleDrop = (e, consultationId) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileUpload(Array.from(e.dataTransfer.files), consultationId);
      e.dataTransfer.clearData();
    }
  };

  const handleCloseReportNameModal = () => {
    setShowReportNameModal(false);
    setSelectedFiles([]);
    setReportName("");
  };

  const handleFileUpload = async (acceptedFiles, consultationId) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      toast.error("No files selected.");
      return;
    }

    const maxSizeMB = 5;
    const allowedTypes = ["application/pdf"];
    const errorMessage = "Only PDF files under 5MB are allowed.";

    const invalidFiles = acceptedFiles.filter(
      (file) =>
        !allowedTypes.includes(file.type) || file.size > maxSizeMB * 1024 * 1024
    );

    if (invalidFiles.length > 0) {
      toast.error(errorMessage);
      return;
    }

    setSelectedFiles(acceptedFiles);
    setActiveConsultationId(consultationId);
    handleShowReportNameModal();
  };

  // Handle file input change
  const handleFileChange = (event, consultationId) => {
    const files = Array.from(event.target.files);
    handleFileUpload(files, consultationId);
  };

  // Handle report name submission and API upload
  const handleReportNameSubmit = async () => {
    if (!reportName.trim()) { toast.error("Please enter a report name."); return }
    if (!currentPatientDetail?.patient?._id || !activeConsultationId) { toast.error("Missing patient or consultation information."); return }
    setIsLoading(true);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("file", file));
      formData.append("user_id", currentPatientDetail?.patient?._id);
      formData.append("report_name", reportName);
      formData.append("consultation_id", activeConsultationId)
      const headers = { "Content-Type": "multipart/form-data", token: TOKEN };
      const response = await axios.post(BASE_URL + UPLOAD_LAB_RESULTS, formData, { headers });

      if (response.data.code === 200 && response.data.status === true) {
        setUploadedFiles((prev) => [
          ...prev,
          ...selectedFiles.map((file) => ({
            file,
            name: reportName,
            size: file.size,
            status: "Completed",
            url: response.data.data,
            consultationId: activeConsultationId,
          })),
        ]);
        if (fileInputRef.current) { fileInputRef.current.value = null }
        toast.success("PDF uploaded successfully!");
        getLabResults(activeConsultationId)
        handleCloseReportNameModal();
      }
      else { toast.error("Upload failed. Please try again.") }
    }
    catch (error) {
      const errorMessage = error.response?.data?.error_description || "An error occurred during upload.";
      toast.error(errorMessage);
    }
    finally {
      setIsLoading(false);
      handleCloseReportNameModal();
    }
  };

  const getLabResults = async (consultationId) => {
    setConsID(consultationId);
    setIsLoading(true);

    try {
      const res = await axios.get(`${BASE_URL}${GET_LAB_RESULTS}`, {
        params: { consultation_id: consultationId, user_id: currentPatientDetail?.patient?._id }, headers
      });
      const json = res.data;
      if (json.status && json.code === 200) { setLabReport(json.data || []); return }
      setLabReport([]);
    }
    catch (err) {
      const error = err.response.data.error_description;
      console.error("Request failed", error);
      setLabReport([]);
    }
    finally { setIsLoading(false) }
  };


  useEffect(() => { getShowMedicalHistory() }, [])

  // Parse AI response for consultation sections
  const parseAIResponse = (response) => {
    if (!response || !response.response) return null;
    const text = response.response;
    const sections = [];
    let parts = [];
    const spaceParts = text.split('Question :').filter(part => part.trim());
    spaceParts.forEach(part => {
      if (part.includes('Question:')) {
        const subParts = part.split('Question:').filter(subPart => subPart.trim());
        parts.push(...subParts);
      }
      else { parts.push(part); }
    });
    parts.forEach((part, index) => {
      const answerIndex = part.indexOf('Answer:') !== -1 ? part.indexOf('Answer:') : part.indexOf('Answer :');
      if (answerIndex !== -1) {
        const question = part.substring(0, answerIndex).trim();
        const answerStartIndex = part.indexOf('Answer:') !== -1 ? answerIndex + 7 : answerIndex + 8;
        let answer = part.substring(answerStartIndex);
        const nextQuestionIndex = answer.search(/Question\s*:/);
        if (nextQuestionIndex !== -1) {
          answer = answer.substring(0, nextQuestionIndex);
        }
        answer = answer.trim();
        if (question && answer) {
          sections.push({
            question: question,
            answer: answer
          });
        }
      }
    });
    return sections;
  };

  const getShowMedicalHistory = async () => {
    setIsLoading(true)
    const payload = { userId: currentPatientDetail?.patient?._id };
    try {
      const response = await axios.post('https://t2tjje1kde.execute-api.us-east-1.amazonaws.com/dev/show', payload,
        { headers: { 'Content-Type': 'application/json' }, timeout: 80000, }
      );
      if (response.status === 200) {
        const parsedSections = parseAIResponse(response.data);
        // if (parsedSections && parsedSections.length > 0) { setConsultationSections(parsedSections) }
        const sortedData = [...response.data].sort((a, b) => {
          const dateA = isNaN(a.timestamp) ? new Date(a.timestamp || 0) : new Date(parseInt(a.timestamp, 10));
          const dateB = isNaN(b.timestamp) ? new Date(b.timestamp || 0) : new Date(parseInt(b.timestamp, 10));
          return dateB - dateA;
        });
        setPatientRecord(sortedData)
        setTotalAccordion(sortedData.length)
        return sortedData;
      }
      return "I'm sorry, I couldn't process your request at the moment.";
    }
    catch (error) {
      if (error.code === 'ECONNABORTED') { return 'Request timed out. The server is taking too long to respond.' }
      return "I'm sorry, there was an error processing your request. Please try again later.";
    }
    finally { setIsLoading(false) }
  };

  const getUpdateMedicalHistory = async (updatedData) => {

    setIsLoading(true)
    const payload = {
      userId: currentPatientDetail?.patient?._id,
      sessionId: activeRecordId,
      chiefComplaint: activeChiefComplaint || "",
      medicalDiagnosis: updatedData.medicalDiagnosis || activeMedicalDiagnosis || "",
      followUps: updatedData.followUps || activeFollowUps || "",
      timestamp: updatedData.timestamp || new Date().toISOString(),
    };
    try {
      const response = await axios.post('https://t2tjje1kde.execute-api.us-east-1.amazonaws.com/dev/showupdate', payload,
        { headers: { 'Content-Type': 'application/json' }, timeout: 80000, }
      );
      if (response.status === 200) {
        const parsedSections = parseAIResponse(response.data);
        // if (parsedSections && parsedSections.length > 0) { setConsultationSections(parsedSections) }
        getShowMedicalHistory();
        return response.data;
      }
      return "I'm sorry, I couldn't process your request at the moment.";
    }
    catch (error) {
      if (error.code === 'ECONNABORTED') { return 'Request timed out. The server is taking too long to respond.' }
      return "I'm sorry, there was an error processing your request. Please try again later.";
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteReport = async (id) => {
    setIsLoading(true);
    const headers = { "token": TOKEN };
    try {
      const response = await axios.delete(BASE_URL + DELETE_LAB_RESULT + "?_id=" + id, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        toast.success('Report Delete Successfully');
        getLabResults(consId)
      }
    }
    catch (err) { console.error('Error deleting user:', err); }
    finally { setIsLoading(false); }
  };

  const handleMedicalDiagnosisSubmit = async () => {
    if (!medicalDiagnosis.trim()) { toast.error("Please enter a medical diagnosis."); return }
    await getUpdateMedicalHistory({ medicalDiagnosis });
    handleClose();
  }

  const handleFollowUpReminderSubmit = async () => {
    if (!followUpReminder.trim()) { toast.error("Please enter a follow-up reminder."); return }
    await getUpdateMedicalHistory({ followUps: followUpReminder });
    handleClose1();
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/patient-record" }}>Patient Record Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >View Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex"><h6 className="comm_page_heading">Patient Records</h6></div>
              <div className="patient_record_accordion">
                <Accordion onSelect={(eventKey) => {
                  if (eventKey === null) return;
                  const record = patientRecord[Number(eventKey)];
                  getLabResults(record.sessionId);
                }}
                >
                  {patientRecord && patientRecord.length > 0 ?
                    patientRecord.map((record, id) => {
                      return (
                        <Accordion.Item key={id} eventKey={String(id)}>
                          <Accordion.Header>Date: {dateFormatter(record?.timestamp)}</Accordion.Header>
                          <Accordion.Body>
                            <Row className="row-gap-5">
                              <Col lg={8}>
                                <h5 className="comm_inner_sub_heading">{" "}Medical History:{" "}</h5>
                                <div className="patient_record_left_outer">
                                  <div className="comm_border_box">
                                    <div className="pat_record_histoy_inn_row">
                                      <div className="pat_record_histoy_inn_col">
                                        <h6>chief complaints:</h6>
                                        <p>{record?.chiefComplaint}</p>
                                      </div>
                                      <div className="pat_record_histoy_inn_col">
                                        <h6>present medical history:</h6>
                                        <p>{record?.currentMedicalHistory}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="comm_border_box">
                                    <div className="d-flex patient_rcrd_inn_row medical_diagnos_outer mb-4">
                                      <div className="d-flex align-items-center medical_diagnos_row">
                                        <h5 className="comm_inner_sub_heading mb-0">medical diagnosis:</h5>
                                      </div>
                                      <div className="edit_btn" onClick={() => handleShow(record)}><MdOutlineModeEdit /></div>
                                    </div>
                                    <p className="mb-0">{record?.medicalDiagnosis}</p>
                                  </div>
                                  <div className="comm_border_box">
                                    <div className="d-flex patient_rcrd_inn_row follow_remind_outer">
                                      <h5 className="comm_inner_sub_heading mb-0">{" "}Follow up reminders:{" "}</h5>
                                      <div className="edit_btn" onClick={() => handleShow1(record)}><MdOutlineModeEdit /></div>
                                    </div>
                                    <p>{record?.followUps}</p>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="comm_row_space_outer">
                                  <div>
                                    <h5 className="comm_inner_sub_heading">Patient Details:</h5>
                                    <div className="patient-detail-outer">
                                      <div className="patient-anme-view">
                                        <h5>patient ID:</h5>
                                        <p>#{currentPatientDetail.patient.patient_id}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>patient name:</h5>
                                        <p>{currentPatientDetail.patient.full_name}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>Phone Number:</h5>
                                        <p>{currentPatientDetail.patient.number}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>Email:</h5>
                                        <p>{currentPatientDetail.patient.email}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>date of consultation:</h5>
                                        <p>{currentPatientDetail.patient.createdAt ? dateFormatter(currentPatientDetail?.patient?.createdAt) : "Not available"}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>age:</h5>
                                        <p>{currentPatientDetail.patient.age}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>Gender:</h5>
                                        <p>{currentPatientDetail.patient.gender}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>Condition:</h5>
                                        <p>{currentPatientDetail.patient.condition}</p>
                                      </div>
                                      <div className="patient-anme-view">
                                        <h5>Status</h5>
                                        <div className="pending-status">
                                          <GoDotFill />
                                          {/* {currentPatientDetail.status} */}
                                          pending
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="comm_border_box">
                                    <h5 className="comm_inner_sub_heading">Lab Results:</h5>
                                    <div className={`file-upload-wrapper ${dragActive ? "drag-active" : ""}`}
                                      onDragEnter={handleDrag}
                                      onDragOver={handleDrag}
                                      onDragLeave={handleDrag}
                                      onDrop={(e) => handleDrop(e, record?.sessionId)}
                                    >
                                      <label className="file-upload-box mb-0">
                                        <input
                                          type="file"
                                          className="file-upload-input"
                                          accept="application/pdf"
                                          ref={fileInputRef}
                                          onChange={(e) => handleFileChange(e, record?.sessionId)} />
                                        <div className="d-flex upload-content">
                                          <figure className="cloud_img"><img src={Cloud} alt="img" className="img-fluid" /></figure>
                                          <div className="drg-rw">
                                            <h5>Choose a file or drag & drop it here</h5>
                                            <p className="mb-0">PDF formats, up to 50MB</p>
                                          </div>
                                        </div>
                                      </label>
                                    </div>


                                    {labReport && labReport.length > 0 ?
                                      labReport.map((report, ID) => {
                                        return (
                                          <div className="pdf_record_row" key={ID}>
                                            <div className="pdf_record_row_inner">
                                              <figure> <img src={PdfImage} alt="img" className="img-fluid" /> </figure>
                                              <div className="pdf-cntnt">
                                                <h5>{report?.report_name}</h5>
                                                <div className="d-fBack to worklex pdf_size_row"><FaCircleCheck /><span>Completed</span></div>
                                              </div>
                                            </div>
                                            <div onClick={() => handleDeleteReport(report?._id)}>
                                              <GoTrash className="trash" />
                                            </div>
                                          </div>
                                        )
                                      })
                                      :
                                      <div className="pdf_record_row">
                                        <div className="pdf_record_row_inner">
                                          <figure><img src={PdfImage} alt="img" className="img-fluid" /></figure>
                                          <div className="pdf-cntnt d-flex align-items-center"><h5>No report found</h5></div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      )
                    })
                    :
                    <h3 className="text-center">No Patient Record Found!!</h3>
                  }
                </Accordion>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered className="comm_modal patient_record_modal">
        <Modal.Body className="p-0">
          <Modal.Header>
            <Modal.Title>Edit Medical Diagnosis</Modal.Title>
            <IoMdCloseCircle onClick={handleClose} />
          </Modal.Header>
          <div className="comm_inner_body_modal">
            <Form.Group className="comn-class-inputs mb-0">
              <Form.Label>medical diagnosis</Form.Label>
              <Form.Control type="text" as="textarea" placeholder="Enter Medical Diagnosis Here"
                style={{ height: "120px", width: "100%", resize: "none" }}
                value={medicalDiagnosis}
                onChange={(e) => setMedicalDiagnosis(e.target.value)}
              />
            </Form.Group>
            <div className="modal_pair_btns">
              <button className="main-outline-btn" onClick={handleClose}>Cancel</button>
              <button className="main-btn" onClick={handleMedicalDiagnosisSubmit} disabled={!medicalDiagnosis.trim()}>Update Diagnosis</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={show1} onHide={handleClose1} centered className="comm_modal patient_record_modal">
        <Modal.Body className="p-0">
          <Modal.Header>
            <Modal.Title>Follow Up Reminder</Modal.Title>
            <IoMdCloseCircle onClick={handleClose1} />
          </Modal.Header>
          <div className="comm_inner_body_modal">
            <Form.Group className="comn-class-inputs mb-0">
              <Form.Label>Follow up Reminder</Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                placeholder="Enter Follow Up Reminder Here"
                style={{ height: "120px", width: "100%", resize: "none" }}
                value={followUpReminder}
                onChange={(e) => setFollowUpReminder(e.target.value)}
              />
            </Form.Group>
            <div className="modal_pair_btns">
              <button className="main-outline-btn" onClick={handleClose1}>Cancel</button>
              <button className="main-btn" onClick={handleFollowUpReminderSubmit} disabled={!followUpReminder.trim()}>Update Reminder</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showReportNameModal} onHide={handleCloseReportNameModal} centered className="comm_modal patient_record_modal">
        <Modal.Body className="p-0">
          <Modal.Header>
            <Modal.Title>Enter Report Name</Modal.Title>
            <IoMdCloseCircle onClick={handleCloseReportNameModal} />
          </Modal.Header>
          <div className="comm_inner_body_modal">
            <Form.Group className="comn-class-inputs mb-0">
              <Form.Label>Report Name</Form.Label>
              <Form.Control type="text" placeholder="Enter Report Name" value={reportName} onChange={(e) => setReportName(e.target.value)} />
            </Form.Group>
            <div className="modal_pair_btns">
              <button className="main-outline-btn" onClick={handleCloseReportNameModal}>Cancel</button>
              <button className="main-btn" onClick={handleReportNameSubmit} disabled={!reportName.trim()}>Save Report</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PatientRecordDetails;